import type {NavScript} from '../navigation.ts'

const animateURLs = [
  '/home.html',
  '/updates/',
  '/projects/',
  '/journal/',
  '/system/',
]

let onResize: null | (() => void) = null

export const onLoad: NavScript['onLoad'] = async () => {
  const linkElem = document.querySelector('link[href="/styles.css"]') as HTMLLinkElement | undefined
  if (!linkElem || !linkElem.sheet) return

  // Mucking with the loaded stylesheet like this is terribly cursed,
  // but it keeps our code relatively clean!
  const bodyClass = document.querySelector('body')?.getAttribute('class')
  const styleSheet = linkElem.sheet
  const rules = Array.from(styleSheet.cssRules)
  const containerRule = rules.find(
    rule => 'selectorText' in rule
      && (rule.selectorText as string) === `.${bodyClass} main`
  ) as CSSStyleRule
  const styles = containerRule.style as CSSStyleDeclaration

  if (!containerRule) return

  onResize = () => {
    const main = document.querySelector('body > main')
    if (!main) return

    const hasScroll = main.scrollHeight > main.clientHeight + 1

    if (hasScroll) {
      styles.setProperty('justify-content', 'initial')
    } else {
      styles.setProperty('justify-content', 'center')
    }
  }

  window.addEventListener('resize', onResize)
  setTimeout(onResize, 1)
}

export const onBeforeUnload: NavScript['onBeforeUnload'] = async () => {
  if (onResize)
    window.removeEventListener('resize', onResize)

  return {continueUnload: true}
}

export const getNavAction: NavScript['getNavAction'] = (nextUrl: string) => {
  if (animateURLs.includes(nextUrl))
    return 'intercept'

  return 'none'
}

export const onInterceptNav : NavScript['onInterceptNav'] = async (nextUrl: string, nextPage: HTMLIFrameElement) => {
  const currentNav = document.querySelector('body > nav')
  const currentContent = document.querySelector('body > main')

  const nextNav = nextPage.contentDocument?.querySelector('body > nav')
  const nextContent = nextPage.contentDocument?.querySelector('body > main')

  if (!(currentNav && currentContent && nextNav && nextContent))
    return {replaceDom: true}

  const mainAnimate = animateMainContent(currentContent, nextContent, nextPage.contentDocument?.body.className)
  const navAnimate = animateNav(currentNav, nextNav, nextUrl)

  await Promise.all([mainAnimate, navAnimate])

  // TODO: this can be true once we figure out why it flickers and avoid that
  // maybe use the new transition spec to mask that where it's supported?
  return {replaceDom: false}
}

async function animateMainContent(currentContent: Element, nextContent: Element, bodyClass?: string) {
  // Hide main section
  currentContent.className = "hidden"
  await new Promise(res => setTimeout(res, 300))

  // Update content and body class
  currentContent.innerHTML = nextContent.innerHTML
  if (bodyClass)
    document.body.className = bodyClass

  if (onResize) onResize()

  // Show main section
  currentContent.className = "showing"
  await new Promise(res => setTimeout(res, 300))

  // Cleanup
  currentContent.removeAttribute("class")
}

async function animateNav(currentNav: Element, nextNav: Element, nextUrl: string) {
  const selectedClass = currentNav.querySelector('li[class^="selected-"]')?.className ?? ''
  const relativeNextUrl = nextNav.querySelector('ul')?.getAttribute('data-current-url') ?? nextUrl
  const nextSelected = currentNav.querySelector(`li:has(a[href="${relativeNextUrl}"])`)

  // Change the sidebar classes
  const navItems = currentNav.querySelectorAll('li')
  navItems.forEach(li => {
    li.className = "unselected"
  })

  if (nextSelected)
    nextSelected.className = selectedClass

  setTimeout(() => {
    navItems.forEach(li => {
      li.classList.remove("unselected")
    })
  }, 200)
}
